<template>
  <div>
    <b-dropdown
      no-caret
      variant="outline-primary"
      size="sm"
      :class="dropdownClass"
      :toggle-class="toggleClass"
      :disabled="loading"
    >
      <template #button-content>
        <b-overlay
          :show="loading"
          class="w-auto"
          spinner-variant="primary"
          spinner-small
          variant="light"
          opacity=".8"
          rounded="full"
        >
          <span class="flex items-center gap-[4px] !py-[5px] !px-[12px]">
            {{ displayText }}
            <span class="k-arrow-down-1 text-[#333333] font-bold" />
          </span>
        </b-overlay>
      </template>
      <b-dropdown-item
        v-for="status in UPGRADE_STATUS_OPTION_LIST"
        :key="status.value"
        :disabled="selectedStatus === status.value"
        :class="selectedStatus === status.value ? 'opacity-70 cursor-not-allowed' : ''"
        @click="handleUpdateStatus(status.value)"
      >
        <span>{{ status.text }}</span>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import {
  CREATOR_STATUS_STYLE,
  UPGRADE_STATUS_OPTION_LIST,
  UNDEFINED_STATUS_TEXT,
} from '../config'

export default {
  name: 'StatusCell',
  props: {
    data: {
      type: Object,
      required: true,
    },
    modalUpgradeConfirmation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      selectedStatus: this.data.status ?? null,
      UPGRADE_STATUS_OPTION_LIST,
    }
  },
  computed: {
    displayText() {
      return CREATOR_STATUS_STYLE[this.selectedStatus]?.label ?? UNDEFINED_STATUS_TEXT
    },
    toggleClass() {
      return `!rounded-full !p-0 ${CREATOR_STATUS_STYLE[this.selectedStatus]?.class ?? ''}`
    },
    dropdownClass() {
      return `[&_.btn-outline-primary]:!border-[${CREATOR_STATUS_STYLE[this.selectedStatus]?.borderColor ?? '#F95031'}]`
    },
  },
  watch: {
    'data.status': {
      handler(newValue, oldValue) {
        this.selectedStatus = newValue ?? null
        this.lastStatus = oldValue
      },
    },
  },
  created() {
    this.lastStatus = this.data.current_status ?? null
  },
  methods: {
    /**
     * Tampilkan modal konfirmasi sebelum mengubah status kreator
     * @param {string} status - nilai status baru (tap, mcn, off, blacklisted)
     */
    async handleUpdateStatus(status) {
      this.lastStatus = this.selectedStatus
      this.selectedStatus = status
      const onCancel = () => {
        this.selectedStatus = this.lastStatus
      }
      try {
        this.loading = true
        this.modalUpgradeConfirmation.showModal({ callback: this.upgradeStatus, onCancel })
      } catch (error) {
        this.selectedStatus = this.lastStatus
        this.$toast_error({ message: 'Gagal memperbarui status creator. Silakan coba lagi.' })
      } finally {
        this.loading = false
      }
    },
    /**
     * PATCH status kreator ke API; rollback UI jika gagal
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    upgradeStatus() {
      return new Promise((resolve, reject) => this.$http_new.patch(`/komclass/api/v1/komlabs/creators/${this.data.id}/status`, { status: this.selectedStatus })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          this.selectedStatus = this.lastStatus
          reject(error)
        }))
    },
  },
}
</script>
